import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { hsaMerchantClassificationProjection } from "./hsa-merchant-classification";

/**
 * Reclassifies the team: screens its catalog, then classifies its MCC when the
 * screen is clear. Refused once Generate KYC has applied the lines at Adyen.
 */
export const runHsaMerchantClassification = {
  name: "runHsaMerchantClassification" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    outcome: z.enum(["paused_for_review", "mcc_review_pending", "classified"]),
    classification: hsaMerchantClassificationProjection,
  }),
};
